import { createContext, useContext, useState, ReactNode } from 'react';
import LoginModal from '../components/login/LoginModal';

interface ModalContextType {
    openLoginModal: () => void;
    closeLoginModal: () => void;
}

const ModalContext = createContext<ModalContextType | undefined>(undefined);

export function useModal() {
    const context = useContext(ModalContext);
    if (!context) {
        throw new Error('useModal must be used within a ModalProvider');
    }
    return context;
}

interface ModalProviderProps {
    children: ReactNode;
}

export function ModalProvider({ children }: ModalProviderProps) {
    const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);

    const openLoginModal = () => {
        console.log('Opening login modal');
        setIsLoginModalOpen(true);
    };
    const closeLoginModal = () => {
        console.log('Closing login modal');
        setIsLoginModalOpen(false);
    };

    return (
        <ModalContext.Provider value={{ 
            openLoginModal, 
            closeLoginModal,
        }}>
            {children}
            <LoginModal 
                isOpen={isLoginModalOpen}
                onClose={closeLoginModal}
            />
        </ModalContext.Provider>
    );
} 